import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import Header from '../../components/Header';
import List from '../../components/List';
import Button from '../../components/Button';
import Layout from '../../commons/layout';
import { Container } from './style';
import { Tab, TabList, Tabs } from '../../components/Tab';
import IconList from '../../assets/img/tab-ic-list.png';
import IconGrid from '../../assets/img/tab-ic-grid.png';

const listData = [];

class Pendentes extends Component {
  constructor() {
    super();
    this.state = {
      grid: true,
    };
    this.goComanda = this.goComanda.bind(this);
  }

  goComanda() {
    this.props.history.push('/comanda');
  }

  toggleHidden(state) {
    this.setState({
      grid: state,
    });
  }

  render() {
    return (
      <Tabs>
        <Layout>
          <Container>
            <Header
              title="Comandas Pendentes"
              subtitle="06 Comandas pendentes no total"
            >
              <TabList>
                <Tab onClick={() => this.toggleHidden(true)}>
                  <img src={IconList} alt="" />
                  Lista
                </Tab>
                <Tab onClick={() => this.toggleHidden(false)}>
                  <img src={IconGrid} alt="" />
                  Grid
                </Tab>
              </TabList>
            </Header>
            <List
              grid={!this.state.grid}
              data={listData}
              print={() => this.mensagem('Teste')}
              search={() => this.mensagem('Teste')}
              itemClick={this.goComanda}
              pagination
              paginationContainer={<Button>Abrir nova comanda</Button>}
            />
          </Container>
        </Layout>
      </Tabs>
    );
  }
}

export default withRouter(Pendentes);
